/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Project
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Project
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    photoURL?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Project
     */
    photosURL?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    targetBudget?: number;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    commercialArea?: number;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    livableArea?: number;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    status: ProjectStatusEnum;
    /**
     * 
     * @type {Organization}
     * @memberof Project
     */
    organization: Organization;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    pricePerMeterSquare?: number;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    pricePerMeterSquareCommercial?: number;
}


/**
 * @export
 */
export const ProjectStatusEnum = {
    Active: 'active',
    Completed: 'completed',
    Archived: 'archived'
} as const;
export type ProjectStatusEnum = typeof ProjectStatusEnum[keyof typeof ProjectStatusEnum];


/**
 * Check if a given object implements the Project interface.
 */
export function instanceOfProject(value: object): value is Project {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('organization' in value) || value['organization'] === undefined) return false;
    return true;
}

export function ProjectFromJSON(json: any): Project {
    return ProjectFromJSONTyped(json, false);
}

export function ProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): Project {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'name': json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'photoURL': json['photoURL'] == null ? undefined : json['photoURL'],
        'photosURL': json['photosURL'] == null ? undefined : json['photosURL'],
        'targetBudget': json['targetBudget'] == null ? undefined : json['targetBudget'],
        'commercialArea': json['commercialArea'] == null ? undefined : json['commercialArea'],
        'livableArea': json['livableArea'] == null ? undefined : json['livableArea'],
        'status': json['status'],
        'organization': OrganizationFromJSON(json['organization']),
        'pricePerMeterSquare': json['pricePerMeterSquare'] == null ? undefined : json['pricePerMeterSquare'],
        'pricePerMeterSquareCommercial': json['pricePerMeterSquareCommercial'] == null ? undefined : json['pricePerMeterSquareCommercial'],
    };
}

export function ProjectToJSON(json: any): Project {
    return ProjectToJSONTyped(json, false);
}

export function ProjectToJSONTyped(value?: Project | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'name': value['name'],
        'address': value['address'],
        'photoURL': value['photoURL'],
        'photosURL': value['photosURL'],
        'targetBudget': value['targetBudget'],
        'commercialArea': value['commercialArea'],
        'livableArea': value['livableArea'],
        'status': value['status'],
        'organization': OrganizationToJSON(value['organization']),
        'pricePerMeterSquare': value['pricePerMeterSquare'],
        'pricePerMeterSquareCommercial': value['pricePerMeterSquareCommercial'],
    };
}

